<template>
  <Transition>
    <div v-if="show" :class="bgVariants({ theme })">
      <!-- <Container> -->
      <Transition name="text">
        <Container v-if="showLoader" class="absolute flex w-full items-center justify-center">
          <span>Hämtar dina uppgifter...</span>
          <LoaderSpinner color="white" class="absolute right-4 h-[40px] w-[40px]" />
        </Container>
        <Container
          v-else-if="!showLoader && hasResult"
          class="absolute flex w-full items-center justify-center"
        >
          <span>Dina uppgifter hämtades!</span>
          <CheckFill class="absolute right-4" />
        </Container>
        <div v-else-if="!showLoader && !hasResult" class="flex w-full items-center justify-center">
          <span>Kunde inte slå upp adressuppgifter!</span>
        </div>
      </Transition>
      <!-- </Container> -->
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useFormLoader } from '@/composables/useFormLoader'
import CheckFill from '../atoms/Icons/CheckFill.vue'
import { Container, THEMES, LoaderSpinner } from 'refresh-ui'
import { cva } from 'class-variance-authority'

const { showLoader, hasResult } = useFormLoader()
const show = ref(false)

withDefaults(
  defineProps<{
    theme?: THEMES
  }>(),
  {
    theme: THEMES.DEFAULT,
  },
)

const updateShow = (value: boolean) => {
  if (value) {
    show.value = value
    return
  }

  if (!value) {
    setTimeout(() => {
      show.value = value
    }, 1000)
  }
}
watch(
  () => showLoader.value,
  val => updateShow(val),
)

const bgVariants = cva(
  'fixed z-50 top-0 left-0 flex h-[73px] w-full items-center justify-center bg-gradient-to-r from-[#F2FBFD]  lg:h-[90px]',
  {
    variants: {
      theme: {
        [THEMES.DJURENS_RATT]: 'to-blue',
        [THEMES.DEFAULT]: 'to-blue',
        [THEMES.RDK]: ' to-purple font-bold',
      },
    },
    defaultVariants: {
      theme: THEMES.DEFAULT,
    },
  },
)
</script>

<style scoped>
.v-enter-active,
.v-leave-active {
  transition: transform 0.8s ease-in-out;
}
.v-enter-from {
  transform: translateY(-100%);
}

.v-leave-to {
  transform: translateY(-100%);
}

.text-enter-active,
.text-leave-active {
  transition: opacity 0.5s ease;
}

.text-enter-from,
.text-leave-to {
  opacity: 0;
}
</style>
